import { localizeFileSize } from 'utils/i18nHelpers';
import { ByteUnit } from 'utils/l10n';

export const cleanFileName = (str: string, ext: string, defaultFileName = 'newFile') => {
  const fileName = str
    .split('.')[0] // remove the ext, if any
    .replace(/[\s]/gi, '-') // replace whitespace with hyphen
    .replace(/[^\w\d\-_]/gi, '') // remove any non-word, non-digit, non-hyphen, or non underscore characters
    .replace(/[-]+/gi, '-') // remove consecutive hyphens
    .replace(/[_]+/gi, '_') // remove consecutive underscores
    .replace(/^[-_]+/i, '') // remove leading hyphens or underscores
    .replace(/[-_]+$/i, '') // remove trailing hyphens or underscores
    .toLowerCase();
  return `${fileName || defaultFileName}.${ext}`;
};

export const getFileSize = (bytes: number) => {
  // express in KB if less than 1 MB
  if (bytes < 1024 * 1024) return localizeFileSize(bytes).formatted;
  // otherwise, express as MB
  return localizeFileSize(bytes, ByteUnit.MB).formatted;
};

export const getFetchQs = (paramObj: Record<string, any>) => {
  const params = new URLSearchParams(paramObj);
  return params.toString();
};

export const getImageType = (mimeType: string): string => {
  const imagePrefix = 'image/';
  const removedPrefix = mimeType.replace(imagePrefix, '');
  return removedPrefix.toUpperCase();
};
